<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
        <b-form>
          <b-card no-header>
            <app-forma-pago
              label="Forma de Pago"
              :nombre="formaPagoNombre"
              :valido="formaPagoValida"
              :lista="formasPagoList"
              :msjInvalido="formaPagoInvalidaMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="formaPagoActualizada">
            </app-forma-pago>  

            <b-form-group
              label="Porcentaje"
              label-for="porcentaje"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="porcentaje"
                v-model.trim= "$v.porcentaje.$model" 
                :state="porcentajeValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="porcentajeFeedback">
                {{ porcentajeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Condiciones"
              label-for="condiciones"
              :label-cols="labelCols"
              horizontal
              description="Por ej. cheques a 30, 60 y 90 dias">
              <b-form-input 
                id="condiciones"
                v-model.trim= "$v.condiciones.$model" 
                :state="condicionesValidas"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="condicionesFeedback">
                {{ condicionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <div slot="footer">
              <b-button size="sm" variant="primary" class="footer-button"
                @click.prevent="save">Grabar</b-button>
              <b-button size="sm" variant="danger" class="footer-button"
                @click.prevent="goList">Cancelar</b-button>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal title="SGC" 
        v-model="modalMsj" 
        header-bg-variant="light"
        ok-only 
        ok-variant="primary footer-button"
        @ok='okAction' 
        @hidden="hiddenAction">
      {{ modalMensaje }}
    </b-modal>
  </div>
</template>

<script>
import FormaPago from '../shared/abmSelect.vue';
import { required, numeric, decimal, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ordenproveedorformapago/getField',
  mutationType: 'ordenproveedorformapago/updateField',
});

export default {
  name: 'ABM',
  props: {
    noRequiereContrato: {
      type: Boolean,
      default: false
    },
    tieneContrato: {
      type: Boolean,
      default: false
    },
    contratoPagare: {
      type: Boolean,
      default: false
    }
  },
  components: {
    appFormaPago: FormaPago
  },
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',

      noValidar: true,

      formaPagoValida: null,
      formaPagoInvalidaMsj: '',
      porcentajeValido: null,
      porcentajeInvalidoMsj: '',
      condicionesValidas: null,
      condicionesInvalidasMsj: '',

      formasPago: [],
      formasPagoList: [],

      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'formaPago',
      'formaPagoId',
      'formaPagoNombre',
      'porcentaje',
      'condiciones',
    ]),
  },  
  created() {
    this.getDatosAdicionales();
  },
  methods: {
    okAction(){
      if (this.modalOkAction) {
        this.modalOkAction();
      }
    },
    hiddenAction(){
      if (this.modalHiddenAction) {
        this.modalHiddenAction();
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this;

      /* Recuperamos las formas de pago habilitadas a partir del proveedor seleccionado */
      let params;
      if (!(/true/i).test(this.noRequiereContrato)) {
        if (!(/true/i).test(this.tieneContrato) | !(/true/i).test(this.contratoPagare)) {
          /* Permitimos todas las formas de pago para usuarios habilitados (administrador + direccion) */
          let userRolId = parseInt(this.$store.getters['user/rolId']);
          if (userRolId != 1 & userRolId != 2) {
            params = {
              habilitadosSinPagare: true,
            }
          }
        }
      }

      this.$store.dispatch('formaspago/getList', params)
        .then(() => {
          vm.formasPago = this.$store.getters['formaspago/list'];
          vm.formasPagoList = this.$store.getters['formaspago/selectList'];
        })
        .catch (error => {
          if (this.modal) {

          } else {
            this.modalOkAction = null;
            this.modalHiddenAction = null;
            this.modalMensaje = "Se produjo un error al recuperar la información de formas de pago.";
            this.modalMsj = true;
          }
        });
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'porcentaje' || validarTodos) {
        if (this.$v.porcentaje.$error) {
          this.porcentajeValido = false;
          if (!this.$v.porcentaje.decimal) {
            this.porcentajeInvalidoMsj = 'El porcentaje debe ser un valor numérico positivo';
          } else {
            if (!this.$v.porcentaje.minValue) {
              this.porcentajeInvalidoMsj = 'El porcentaje ingresado no es válido';
            }      
          }
        } else {
          this.porcentajeValido = null;
          this.porcentajeInvalidoMsj = '';
        }
      }

      if (campo == "condiciones" || validarTodos) {
        if (this.$v.condiciones.$error) {
          this.condicionesValidas = false;
          if (!this.$v.condiciones.maxLength) {
            this.condicionesInvalidasMsj = 'Las condiciones sólo pueden contener hasta 50 caracteres';
          }
        } else {
          this.condicionesValidas = null;
          this.condicionesInvalidasMsj = '';
        }
      }
    },
    save () {
      let save = Boolean(true);

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      this.$v.$touch();

      let formaPago;
      if (this.formaPagoNombre) {
        formaPago = this.getSelected(this.formasPago, this.formaPagoNombre);
      }
      this.$store.dispatch('ordenproveedorformapago/setFormaPago', formaPago);

      let formaPagoError = true;
      if (this.formaPago) {
        if (this.formaPago.id) {
          if (this.formaPago.id != 0) {
            formaPagoError = false;
          }
        }
      }
      if (formaPagoError) {
        save = Boolean(false);
        this.formaPagoValida = false;
        this.formaPagoInvalidaMsj = "Debe seleccionar la forma de pago correspondiente.";
      }

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('ordenproveedorformapago/save')
            .then(() => {
              this.$emit('updateFormaPago', 
                this.$store.getters['ordenproveedorformapago/ordenProveedorFormaPago']);
            })
            .catch( error => {
              this.modalOkAction = null;
              this.modalHiddenAction = null;
              this.modalMensaje = error;
              this.modalMsj = true;
            })
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$emit('closeFormaPago');
    },
    formaPagoActualizada(formaPagoNombre) {
      this.formaPagoNombre = formaPagoNombre;

      this.formaPagoValida = null;
      this.formaPagoInvalidaMsj = '';
    }
  },
  watch: {
  },    
  validations: {
    porcentaje: {
      decimal
    },
    condiciones: {
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
